var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdvanceFilterOption = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 100,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#advance-filter-option_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 79.5,
  cy: 50.5,
  r: 44.5,
  fill: "#FFFBF3"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#advance-filter-option_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.1,
  d: "M15 45.683A4.683 4.683 0 0 1 19.683 41h42.634A4.683 4.683 0 0 1 67 45.683v38.634A4.683 4.683 0 0 1 62.317 89H19.683A4.683 4.683 0 0 1 15 84.317z"
})), /*#__PURE__*/React.createElement("rect", {
  width: 66.146,
  height: 41.561,
  x: 7.293,
  y: 41.793,
  fill: "#fff",
  fillOpacity: 0.9,
  rx: 4.39
}), /*#__PURE__*/React.createElement("rect", {
  width: 66.146,
  height: 41.561,
  x: 7.293,
  y: 41.793,
  stroke: "#fff",
  strokeWidth: 0.585,
  rx: 4.39
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeWidth: 0.585,
  clipPath: "url(#advance-filter-option_svg__c)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19.292,
  cy: 54.671,
  r: 5.561,
  fill: "#8DB8E3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33.341,
  cy: 54.671,
  r: 5.561,
  fill: "#9999CD"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47.389,
  cy: 54.671,
  r: 5.561,
  fill: "#C09CC8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61.438,
  cy: 54.671,
  r: 5.561,
  fill: "#CCAED4"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeWidth: 0.585,
  clipPath: "url(#advance-filter-option_svg__d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19.292,
  cy: 70.476,
  r: 5.561,
  fill: "#9FB493"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33.341,
  cy: 70.476,
  r: 5.561,
  fill: "#BECAB4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47.389,
  cy: 70.476,
  r: 5.561,
  fill: "#E2EB92"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61.438,
  cy: 70.476,
  r: 5.561,
  fill: "#F9F395"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#advance-filter-option_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.1,
  d: "M50.049 22.228a5.09 5.09 0 0 1 5.09-5.091h78.854a5.09 5.09 0 0 1 5.091 5.09v12.728a5.09 5.09 0 0 1-5.091 5.09H55.14a5.09 5.09 0 0 1-5.091-5.09z"
})), /*#__PURE__*/React.createElement("rect", {
  width: 93.914,
  height: 25.103,
  x: 47,
  y: 9.5,
  fill: "#FDF8F8",
  rx: 2.897
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FAD200",
  d: "M59.585 15.478a.241.241 0 0 1 .456 0l1.429 4.173a.24.24 0 0 0 .228.163h4.594c.237 0 .332.306.137.44l-3.694 2.549a.24.24 0 0 0-.092.277l1.417 4.138a.241.241 0 0 1-.366.277l-3.744-2.583a.24.24 0 0 0-.274 0l-3.744 2.583a.241.241 0 0 1-.365-.277l1.416-4.138a.24.24 0 0 0-.091-.277l-3.695-2.549a.241.241 0 0 1 .137-.44h4.594a.24.24 0 0 0 .229-.163zM76.77 15.478a.241.241 0 0 1 .457 0l1.428 4.173a.24.24 0 0 0 .229.163h4.594c.237 0 .332.306.137.44l-3.695 2.549a.24.24 0 0 0-.091.277l1.416 4.138a.241.241 0 0 1-.365.277l-3.744-2.583a.24.24 0 0 0-.274 0l-3.744 2.583a.241.241 0 0 1-.366-.277l1.417-4.138a.24.24 0 0 0-.092-.277l-3.695-2.549a.241.241 0 0 1 .137-.44h4.595a.24.24 0 0 0 .228-.163zM93.958 15.478a.241.241 0 0 1 .457 0l1.428 4.173a.24.24 0 0 0 .228.163h4.594c.237 0 .332.306.137.44l-3.694 2.549a.24.24 0 0 0-.092.277l1.417 4.138a.241.241 0 0 1-.366.277l-3.744-2.583a.24.24 0 0 0-.274 0l-3.744 2.583a.241.241 0 0 1-.365-.277l1.416-4.138a.24.24 0 0 0-.091-.277l-3.695-2.549a.241.241 0 0 1 .137-.44h4.594a.24.24 0 0 0 .228-.163zM111.143 15.478a.242.242 0 0 1 .457 0l1.428 4.173a.24.24 0 0 0 .229.163h4.594c.237 0 .332.306.137.44l-3.695 2.549a.24.24 0 0 0-.091.277l1.416 4.138a.241.241 0 0 1-.365.277l-3.744-2.583a.24.24 0 0 0-.274 0l-3.744 2.583a.242.242 0 0 1-.366-.277l1.417-4.138a.24.24 0 0 0-.092-.277l-3.695-2.549a.242.242 0 0 1 .138-.44h4.594a.24.24 0 0 0 .228-.163zM128.329 15.478a.242.242 0 0 1 .457 0l1.428 4.173a.24.24 0 0 0 .228.163h4.594c.237 0 .332.306.138.44l-3.695 2.549a.24.24 0 0 0-.092.277l1.417 4.138a.242.242 0 0 1-.366.277l-3.744-2.583a.24.24 0 0 0-.274 0l-3.744 2.583a.241.241 0 0 1-.365-.277l1.416-4.138a.24.24 0 0 0-.091-.277l-3.695-2.549a.241.241 0 0 1 .137-.44h4.594a.24.24 0 0 0 .229-.163z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#advance-filter-option_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.1,
  d: "M86 77.67A4.67 4.67 0 0 1 90.67 73h60.659A4.67 4.67 0 0 1 156 77.67v9.66a4.67 4.67 0 0 1-4.671 4.67H90.671A4.67 4.67 0 0 1 86 87.33z"
})), /*#__PURE__*/React.createElement("rect", {
  width: 73.423,
  height: 20.435,
  x: 80.292,
  y: 66.792,
  fill: "#fff",
  fillOpacity: 0.9,
  rx: 4.379
}), /*#__PURE__*/React.createElement("rect", {
  width: 73.423,
  height: 20.435,
  x: 80.292,
  y: 66.792,
  stroke: "#fff",
  strokeWidth: 0.584,
  rx: 4.379
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeOpacity: 0.05,
  strokeWidth: 4.671,
  d: "M87.006 77.311 147 77.005"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFD6CC",
  strokeLinecap: "round",
  strokeWidth: 4.671,
  d: "M87.209 77.311h22.854"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#advance-filter-option_svg__g)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 109.195,
  cy: 77.009,
  r: 3.503,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 109.195,
  cy: 77.009,
  r: 2.919,
  fill: "#FF3000"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#advance-filter-option_svg__h)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  x: 90.117,
  y: 40.117,
  fill: "#008060",
  rx: 4.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M95.014 45.013c0-.46.373-.833.833-.833h9.994c.46 0 .833.373.833.833v2.499c0 .22-.088.432-.244.588l-3.921 3.92v2.987a.83.83 0 0 1-.244.59l-1.665 1.665a.833.833 0 0 1-1.422-.59v-4.651l-3.92-3.92a.83.83 0 0 1-.244-.59z",
  clipRule: "evenodd"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "advance-filter-option_svg__b",
  width: 98.829,
  height: 94.829,
  x: -8.415,
  y: 17.585,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_18894_76582",
  stdDeviation: 11.707
})), /*#__PURE__*/React.createElement("filter", {
  id: "advance-filter-option_svg__e",
  width: 139.944,
  height: 73.818,
  x: 24.594,
  y: -8.318,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_18894_76582",
  stdDeviation: 12.727
})), /*#__PURE__*/React.createElement("filter", {
  id: "advance-filter-option_svg__f",
  width: 116.708,
  height: 65.708,
  x: 62.646,
  y: 49.646,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_18894_76582",
  stdDeviation: 11.677
})), /*#__PURE__*/React.createElement("filter", {
  id: "advance-filter-option_svg__g",
  width: 10.925,
  height: 10.926,
  x: 104.385,
  y: 72.2,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.653,
  dy: 0.653
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.98
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.921569 0 0 0 0 0.341176 0 0 0 0 0.341176 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_18894_76582"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_18894_76582",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "advance-filter-option_svg__h",
  width: 62.117,
  height: 62.117,
  x: 70,
  y: 40,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect1_dropShadow_18894_76582"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.304183 0 0 0 0 0.0365019 0 0 0 0 0 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_18894_76582"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect2_dropShadow_18894_76582"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.329688 0 0 0 0 0.103266 0 0 0 0 0.0535635 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_18894_76582",
  result: "effect2_dropShadow_18894_76582"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_18894_76582",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "advance-filter-option_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h160v100H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "advance-filter-option_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.023 48.524h52.683v12.293H14.023z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "advance-filter-option_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.023 64.33h52.683v12.292H14.023z"
})))));
export { SvgAdvanceFilterOption as ReactComponent };
export default __webpack_public_path__ + "static/media/advance-filter-option.243a5e92.svg";